<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import { mapState } from 'vuex'
  import { socialLoginOptions } from '@/config/socialLogins'

  export default {
    name: 'SocialLoginOptions',
    computed: {
      ...mapState('auth', [ 'signup_config' ]),
      socialLoginOptions() {
        return socialLoginOptions
      },
    },
    methods: {
      hasSocialLogin(signup_config) {
        return Boolean(signup_config && signup_config.social && signup_config.social.length)
      },
      socialLoginBtnTitle(socialOption) {
        return this.$t('my_account.login.socialOptions')[socialOption.network] || socialOption.fallbackTitle
      },
    },
  }
</script>
